export const onScroll = {
    mounted: function (el, binding) {
        let animationClass = binding.value.animation
        let offsetPixels = 1000
        let f = function () {
            let pos = getPosition(el)
            let offsetTime = pos.y - offsetPixels
            let animationArray = animationClass.split(' ');
            if (window.scrollY > offsetTime) {
                el.classList.remove('hidden')
                el.classList.add(...animationArray)
            } else if (window.scrollY < offsetTime - offsetPixels && el.classList.contains('animate__animated')) {
                el.classList.add('hidden')
                el.classList.remove(...animationArray)
            }
        };
        //add event listener
        window.addEventListener('scroll', f);
        //get the position of the element
        function getPosition(element) {
            let xPosition = 0;
            let yPosition = 0;
            while (element) {
                xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
                yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
                element = element.offsetParent;
            }
            return { x: xPosition, y: yPosition };
        }
    },
}
